// Module
var code = "<div class=\"sb-user-image\"> {{ $ctrl.initials }} <md-tooltip ng-if=\"$ctrl.displayName\">{{$ctrl.displayName}}</md-tooltip> </div> ";
// Exports
var _module_exports =code;;
var path = '/var/lib/jenkins/workspace/Sablono_sb-bimtime_master/app/scripts/common/ui-elements/directives/sbUserImage/sbUserImage.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;